import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RouteMapper } from '@app/mappers/route.mapper';
import { DeviceService } from '@app/services/device.service';
import { MortgagesService } from '@app/services/mortgages.service';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';

@Injectable({ providedIn: 'root' })
export class MortgageResolver {
    private readonly router = inject(Router);
    protected readonly mortgagesService = inject(MortgagesService);
    private readonly deviceService = inject(DeviceService);

    isDesktop: boolean;

    constructor() {
        this.deviceService.isDesktopObservable.subscribe((isDesktop: boolean) => {
            this.isDesktop = isDesktop;
        });
    }

    public resolve(route: ActivatedRouteSnapshot): Observable<MortgageInterface> {
        if (!this.mortgagesService.mortgage) {
            const id = RouteMapper.findParamRecursively(route, 'mortgageId');
            if (id) {
                // @API cases/mortgage.get
                this.mortgagesService.get(id).then(
                    (mortgage) => {
                        return mortgage;
                    },
                    (error) => {
                        this.router.navigate([this.isDesktop ? '/dashboard' : '/mobile/dashboard']);
                        console.error(error);
                    }
                );
            }
        } else {
            return of(null);
        }
    }
}
